var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_2903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9948 0.747022C40.9503 0.2946 40.6217 0 40.1458 0H0.854167L0.747022 0.00516733C0.2946 0.0496811 0 0.378274 0 0.854167V34.1667L0.00516733 34.2738C0.0496811 34.7262 0.378274 35.0208 0.854167 35.0208H14.7771L12.5563 39.2917H11.1042L10.997 39.2968C10.5446 39.3413 10.25 39.6699 10.25 40.1458C10.25 40.6583 10.5917 41 11.1042 41H24.0625C23.4777 40.4839 22.9436 39.9116 22.4687 39.2917H14.4354L16.6562 35.0208H20.3834C20.2396 34.466 20.1344 33.8955 20.071 33.3125H1.70833V29.0417H20.3674C20.5165 28.4537 20.7089 27.8831 20.9412 27.3333H1.70833V1.70833H39.2917V22.4687C39.9116 22.9436 40.4839 23.4777 41 24.0625V0.854167L40.9948 0.747022Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 44C38.6274 44 44 38.6274 44 32C44 25.3726 38.6274 20 32 20C25.3726 20 20 25.3726 20 32C20 38.6274 25.3726 44 32 44ZM32 42C37.5229 42 42 37.5229 42 32C42 26.4772 37.5229 22 32 22C26.4772 22 22 26.4772 22 32C22 37.5229 26.4772 42 32 42Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 27L30.2 30.2L27 37L33.8 33.8L37 27Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 21H33V24H31V21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 40H33V43H31V40Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 33V31H24V33H21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 33V31H43V33H40Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_2903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDelivery);
export default __webpack_public_path__ + "static/media/order-delivery.d77ac919f001754b9f771daffa9b431c.svg";
export { ForwardRef as ReactComponent };